// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3KRbm","legacyBtn":"MutateMid_legacyBtn__2hZuK"};